import React from 'react'
import { IPricingMethod, Unit } from '@/model/types/goods'
import { getBEMCls } from '@/utils/classname'
import { Row } from '@/components/layout/layout'
import Iconfont from '@/components/iconfont/iconfont'
import classNames from 'classnames'
import { transfromNumberToHanzi } from '@/utils'
import './prices-popper.scss'

interface IProps {
    pricingMethod: IPricingMethod[]
    stockUnit: Unit
}

export const PricesPopper: React.FC<IProps> = props => {
    const cls = (...args: string[]) => getBEMCls('pricesPopper', ...args)

    return (
        <div className={cls()}>
            {props.pricingMethod.map((item, index) => (
                <Row
                    className={classNames(
                        cls('item'),
                        index !== props.pricingMethod.length - 1 ? cls('border') : cls('last'),
                    )}
                    key={item.id}
                >
                    <div className={cls('left')}>售价{transfromNumberToHanzi(index + 1)}：</div>
                    <div className={cls('right')}>
                        <Row>
                            <div>
                                {item.sale_prices.map(val => (
                                    <div key={val.id}>
                                        购买量{'>='}
                                        {val.threshold}；
                                        <span className={cls('price')}>
                                            {val.sale_price}元/{val.sale_unit.name}
                                        </span>
                                    </div>
                                ))}
                            </div>
                            {+item.member_price.sale_price > 0 && (
                                <div className={cls('memberPrice')}>
                                    <Iconfont name="icon8huiyuanjia-12" size={12}></Iconfont>
                                    <span data-margin-left-3>
                                        {item.member_price.sale_price}元/{item.member_price.sale_unit.name}
                                    </span>
                                </div>
                            )}
                        </Row>
                        <Row data-color-999>
                            {item.sales_unit_ratio > 1 && (
                                <div>
                                    一{props.stockUnit.name}={item.sales_unit_ratio}
                                    {item.sales_unit.name}
                                </div>
                            )}
                            {item.price_annotation && <div>{item.price_annotation}</div>}
                        </Row>
                    </div>
                </Row>
            ))}
        </div>
    )
}
